import { Dialog, DialogContent, DialogTitle, styled } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

type PropTypes = {}

const StyledDialogContent = styled(DialogContent)({
  padding: '20px',
  textAlign: 'center',
})

const InitialLoadingDialog = (props: PropTypes) => {
  const translate = useTranslate()
  return (
    <Dialog open={true}>
      <DialogTitle>{translate('Loading...')}</DialogTitle>
      <StyledDialogContent>
        <p>{translate('Fetching available products and pricing information...')}</p>
      </StyledDialogContent>
    </Dialog>
  )
}

export default InitialLoadingDialog
